import { render } from "./EditNewCustomerPage.vue?vue&type=template&id=24929053&ts=true"
import script from "./EditNewCustomerPage.vue?vue&type=script&lang=ts"
export * from "./EditNewCustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__